export const DELETE_INVENTORY_REQUEST = "DELETE_INVENTORY_REQUEST";
export const DELETE_INVENTORY_SUCCESS = "DELETE_INVENTORY_SUCCESS";
export const DELETE_INVENTORY_FAILURE = "DELETE_INVENTORY_FAILURE";
